import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { isImage, prettyFileSize } from 'utils';
import Avatar from '../Avatar';
import IconButton from '../IconButton';
import { DeleteIcon, FileIcon } from '../icons';

export const FileAttachment = ({ file, url, onRemove }) => {
  const size = file && (file.size || file.file_size);

  const isImageFile = isImage(file?.name || url);

  const renderAvatar = () => {
    if (isImageFile) {
      return (
        <Paper
          variant="outlined"
          sx={{
            width: 64,
            height: 48,
            borderRadius: 0.5,
            p: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={url || file.preview} className="img-fluid" />
        </Paper>
      );
    }
    return (
      <Avatar size="small">
        <FileIcon />
      </Avatar>
    );
  };

  return (
    <Paper variant="containedVariant">
      <Stack direction="row" alignItems="center">
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          sx={{ px: 2, py: 1, flex: 1 }}
        >
          {renderAvatar()}
          <Typography fontWeight={500} sx={{ flex: 1 }}>
            {file?.name}
          </Typography>
          <Typography fontWeight={500} color="text.secondary">
            {size && prettyFileSize(size)}
          </Typography>
        </Stack>
        {onRemove && (
          <>
            <Divider orientation="vertical" flexItem />
            <IconButton
              onClick={(e) => onRemove(e, file)}
              icon={<DeleteIcon />}
              color="error"
              variant="text"
              sx={{ m: 1 }}
            />
          </>
        )}
      </Stack>
    </Paper>
  );
};

const FileAttachments = ({ files, onRemove, ...rest }) => {
  return (
    <Stack spacing={1.5} {...rest}>
      {files.map((file, index) => (
        <FileAttachment key={index} file={file} onRemove={onRemove} />
      ))}
    </Stack>
  );
};

FileAttachments.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ).isRequired,
  onRemove: PropTypes.func,
};

export default FileAttachments;
